import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { EarningsOwnerType } from '@services/earnings/types/earnings-owner-type';
import { EarningsResponse } from '@services/earnings/types/earnings-response';

export class ListEarnings implements LoadingAction {
  readonly type = actions.LIST_EARNINGS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public key: EarningsOwnerType,
    public ownerId: string,
    public dsp?: string,
    public reportDate?: string,
    public eligibleDate?: number
  ) {}
}

export class ListEarningsSuccess implements LoadingAction {
  readonly type = actions.LIST_EARNINGS_SUCCESS;
  readonly isLoading = false;

  constructor(
    public key: EarningsOwnerType,
    public earnings: EarningsResponse[]
  ) {}
}

export class ListEarningsError implements ErrorAction {
  readonly type = actions.LIST_EARNINGS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetTotalEarnings implements LoadingAction {
  readonly type = actions.GET_TOTAL_EARNINGS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public key: EarningsOwnerType, public ownerId: string) {}
}

export class GetTotalEarningsSuccess implements LoadingAction {
  readonly type = actions.GET_TOTAL_EARNINGS_SUCCESS;
  readonly isLoading = false;

  constructor(
    public key: EarningsOwnerType,
    public ownerId: string,
    public total: Dinero.Dinero
  ) {}
}

export class GetTotalEarningsError implements ErrorAction {
  readonly type = actions.GET_TOTAL_EARNINGS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ListDeactivatedArtistEarnings implements LoadingAction {
  readonly type = actions.LIST_DEACTIVATED_ARTIST_EARNINGS;
  readonly isLoading = true;

  constructor(public artistId: string) {}
}

export class ListDeactivatedArtistEarningsSuccess implements LoadingAction {
  readonly type = actions.LIST_DEACTIVATED_ARTIST_EARNINGS_SUCCESS;
  readonly isLoading = false;

  constructor(public artistId: string, public earnings: EarningsResponse[]) {}
}

export class ListDeactivatedArtistEarningsError implements ErrorAction {
  readonly type = actions.LIST_DEACTIVATED_ARTIST_EARNINGS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GenerateExportUrl implements LoadingAction {
  readonly type = actions.GENERATE_EXPORT_URL;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public ownerType: EarningsOwnerType,
    public ownerId: string,
    public reportFormat: 'monthly' | 'yearly' | 'all',
    public reportDate: string,
    public reportType: 'detail' | 'summary' = 'summary'
  ) {}
}

export class GenerateExportUrlSuccess implements LoadingAction {
  readonly type = actions.GENERATE_EXPORT_URL_SUCCESS;
  readonly isLoading = false;

  constructor(public requestId: string, public ownerId: string) {}
}

export class GenerateExportUrlError implements ErrorAction {
  readonly type = actions.GENERATE_EXPORT_URL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetEarningsExportUrl implements LoadingAction {
  readonly type = actions.GET_EARNINGS_EXPORT_URL;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(
    public requestId: string,
    public ownerId: string,
    public retry: number = 0
  ) {}
}

export class GetEarningsExportUrlSuccess implements LoadingAction {
  readonly type = actions.GET_EARNINGS_EXPORT_URL_SUCCESS;
  readonly isLoading = false;

  constructor(public url: string) {}
}

export class GetEarningsExportUrlError implements ErrorAction {
  readonly type = actions.GET_EARNINGS_EXPORT_URL_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type EarningsActions =
  | ListEarnings
  | ListEarningsSuccess
  | ListEarningsError
  | GetTotalEarnings
  | GetTotalEarningsSuccess
  | GetTotalEarningsError
  | ListDeactivatedArtistEarnings
  | ListDeactivatedArtistEarningsSuccess
  | ListDeactivatedArtistEarningsError
  | GenerateExportUrl
  | GenerateExportUrlSuccess
  | GenerateExportUrlError
  | GetEarningsExportUrl
  | GetEarningsExportUrlSuccess
  | GetEarningsExportUrlError;
